'use client';

import React, { useState } from 'react';
import { motion } from 'framer-motion';

const contactInfo = [
  {
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.5}
        className="w-5 h-5 pointer-events-none"
      >
        <path d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
        <path d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
    label: 'Alamat',
    value:
      'Jl. Bogor Rawa Indah No.45, RW.01, Setiamulya, Kec. Tarumajaya, Kabupaten Bekasi, Jawa Barat 17213',
    sub: 'Workshop buka Senin–Sabtu, 08.00–17.00',
  },
  {
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.5}
        className="w-5 h-5 pointer-events-none"
      >
        <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.1 10.73 19.79 19.79 0 01.05 2.11 2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
      </svg>
    ),
    label: 'Telepon',
    value: '+62 813-2282-297',
    sub: 'Tersedia 24 jam via WhatsApp',
  },
  {
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.5}
        className="w-5 h-5 pointer-events-none"
      >
        <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    ),
    label: 'Email',
    value: 'indocuttinglaser1@gmail.com',
    sub: 'Respon dalam 1×24 jam kerja',
  },
  {
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.5}
        className="w-5 h-5 pointer-events-none"
      >
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </svg>
    ),
    label: 'Jam Operasional',
    value: 'Senin – Sabtu: 08.00 – 17.00',
    sub: 'produksi aktif 8 jam',
  },
];

export default function ContactContent() {
  const [formData, setFormData] = useState({ name: '', phone: '', service: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const msg = `Halo IndoCuttingLaser!%0A%0ANama: ${formData.name}%0ATelepon: ${formData.phone}%0ALayanan: ${formData.service}%0APesan: ${formData.message}`;
    window.open(`https://wa.me/628132282297?text=${msg}`, '_blank');
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3000);
  };

  return (
    <>
      {/* Hero */}
      <section className="relative py-24 px-4 md:px-8 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-accent/5 to-transparent pointer-events-none" />
        <div className="max-w-7xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          >
            <span className="text-xs uppercase tracking-widest text-accent font-semibold mb-6 block">
              Hubungi Kami
            </span>
            <h1 className="text-5xl md:text-7xl font-bold text-foreground tracking-tight mb-6">
              Konsultasi & Pemesanan
            </h1>
            <p className="text-muted-foreground text-lg max-w-2xl mx-auto leading-relaxed">
              Tim kami siap membantu Anda 24 jam. Dapatkan konsultasi teknis gratis dan penawaran
              terbaik untuk proyek Anda.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Contact Grid */}
      <section className="pb-24 px-4 md:px-8">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16">
          {/* Left: Info + Map */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="flex flex-col gap-10"
          >
            {/* Contact Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {contactInfo.map((info, i) => (
                <div
                  key={i}
                  className="bg-card rounded-2xl p-6 shadow-soft border border-border card-hover flex flex-col justify-between"
                >
                  <div>
                    <div className="w-10 h-10 rounded-xl bg-accent/10 flex items-center justify-center text-accent mb-4">
                      {info.icon}
                    </div>
                    <p className="text-[10px] uppercase tracking-widest text-muted-foreground mb-2 font-bold">
                      {info.label}
                    </p>
                    <p className="text-foreground font-bold text-sm mb-2 leading-snug">
                      {info.value}
                    </p>
                  </div>
                  <p className="text-muted-foreground text-xs mt-2 italic">{info.sub}</p>
                </div>
              ))}
            </div>

            {/* Map placeholder */}
            <div className="bg-card rounded-3xl overflow-hidden border border-border shadow-soft h-72 relative group">
              <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-accent/5 flex flex-col items-center justify-center gap-4">
                <div className="w-14 h-14 rounded-full bg-accent/20 flex items-center justify-center text-accent shadow-lg transition-transform group-hover:scale-110">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={1.5}
                    className="w-7 h-7 pointer-events-none"
                  >
                    <path d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <div className="text-center">
                  <p className="text-foreground font-bold text-lg">Workshop IndoCuttingLaser</p>
                  <p className="text-muted-foreground text-sm">Bogor Rawa Indah, Tarumajaya, Kabupaten Bekasi, Jawa Barat</p>
                </div>
                <a
                  href="https://maps.app.goo.gl/mYPpGHJ2pbCozrEP6"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-8 py-4 rounded-full bg-accent text-white text-sm font-bold shadow-accent/20 shadow-lg hover:shadow-accent/40 transition-all active:scale-95"
                >
                  Buka Google Maps
                </a>
              </div>
            </div>

            {/* WhatsApp Quick CTA */}
            {/* --- WHATSAPP QUICK CTA --- */}
            <a
              href="https://wa.me/628132282297"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-5 bg-green-500 hover:bg-green-600 text-white rounded-3xl p-6 transition-all duration-300 hover:-translate-y-2 shadow-xl shadow-green-500/20 active:scale-95 group relative z-10 w-full cursor-pointer"
            >
              <div className="w-14 h-14 rounded-2xl bg-white/20 flex items-center justify-center flex-shrink-0">
                <svg
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="w-8 h-8 pointer-events-none"
                >
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                </svg>
              </div>
              <div className="flex-1">
                <p className="font-bold text-lg">Chat WhatsApp Langsung</p>
                <p className="text-white/80 text-sm">Respon cepat, konsultasi gratis</p>
              </div>

              {/* --- BAGIAN YANG DIPERBAIKI --- */}
              <div className="p-20 -mr-20">
                {' '}
                {/* Menambah padding tak terlihat agar area klik panah meluas */}
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={3}
                  className="w-6 h-6 transition-transform group-hover:translate-x-2 pointer-events-none"
                >
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </div>
            </a>
          </motion.div>

          {/* Right: Contact Form */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          >
            <div className="bg-card rounded-3xl shadow-xl border border-border p-8 md:p-12 relative overflow-hidden">
              <h2 className="text-3xl font-bold text-foreground mb-3">Kirim Pesan</h2>
              <p className="text-muted-foreground text-sm mb-10 leading-relaxed">
                Isi form di bawah dan tim kami akan segera menghubungi Anda melalui WhatsApp untuk
                detail penawaran.
              </p>

              <form onSubmit={handleSubmit} className="flex flex-col gap-6">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div className="space-y-2">
                    <label className="block text-xs font-bold text-foreground uppercase tracking-widest">
                      Nama Lengkap *
                    </label>
                    <input
                      type="text"
                      required
                      placeholder="Budi Santoso"
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                      className="w-full px-5 py-4 rounded-2xl bg-background border border-input text-foreground text-sm focus:ring-2 focus:ring-accent focus:border-transparent transition-all outline-none"
                    />
                  </div>
                  <div className="space-y-2">
                    <label className="block text-xs font-bold text-foreground uppercase tracking-widest">
                      No. WhatsApp *
                    </label>
                    <input
                      type="tel"
                      required
                      placeholder="0812xxxxxxxx"
                      value={formData.phone}
                      onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                      className="w-full px-5 py-4 rounded-2xl bg-background border border-input text-foreground text-sm focus:ring-2 focus:ring-accent focus:border-transparent transition-all outline-none"
                    />
                  </div>
                </div>

                <div className="space-y-2">
                  <label className="block text-xs font-bold text-foreground uppercase tracking-widest">
                    Layanan yang Dibutuhkan
                  </label>
                  <select
                    value={formData.service}
                    onChange={(e) => setFormData({ ...formData, service: e.target.value })}
                    className="w-full px-5 py-4 rounded-2xl bg-background border border-input text-foreground text-sm focus:ring-2 focus:ring-accent outline-none appearance-none cursor-pointer transition-all"
                  >
                    <option value="">Pilih layanan...</option>
                    <option value="Laser Cutting Metal">Laser Cutting Metal</option>
                    <option value="Laser Cutting CO2">Laser Cutting CO2</option>
                    <option value="CNC Router">CNC Router</option>
                    <option value="Stainless Steel Cutting">Stainless Steel Cutting</option>
                    <option value="Nomor Rumah & Plakat">Nomor Rumah & Plakat</option>
                    <option value="Lainnya">Lainnya</option>
                  </select>
                </div>

                <div className="space-y-2">
                  <label className="block text-xs font-bold text-foreground uppercase tracking-widest">
                    Deskripsi Proyek *
                  </label>
                  <textarea
                    required
                    rows={5}
                    placeholder="Contoh: Saya ingin potong plat besi ukuran 2x1 meter motif batik jumlah 10 lembar..."
                    className="relative z-10 block w-full min-h-[160px] px-5 py-4 rounded-2xl bg-background border border-input text-foreground text-base leading-relaxed focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all resize-none placeholder:text-muted-foreground"
                  />
                </div>

                <button
                  type="submit"
                  disabled={submitted}
                  className={`relative w-full py-8 rounded-full font-bold text-base transition-all duration-300 flex items-center justify-center gap-3 shadow-lg active:scale-[0.97] group overflow-hidden ${
                    submitted
                      ? 'bg-accent text-white'
                      : 'bg-[#25D366] hover:bg-[#20ba5a] text-white shadow-green-500/20'
                  }`}
                >
                  {/* Span ini memastikan konten tetap di tengah dan tidak menghalangi klik */}
                  <span className="relative z-10 flex items-center justify-center gap-3 pointer-events-none">
                    <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                    </svg>
                    {submitted ? 'Terkirim! ✓' : 'Kirim via WhatsApp'}
                  </span>

                  {/* Invisible click layer untuk menjamin seluruh area tombol tertutup area klik */}
                  <div className="absolute inset-0 pointer-events-none z-0 bg-transparent" />
                </button>
              </form>
            </div>
          </motion.div>
        </div>
      </section>
    </>
  );
}
